import { IconEnvelopeBanOutline18 as MailXIcon } from "nucleo-ui-outline-18"

import type { WorkspaceInvite } from "@productlane/zero"
import { Avatar, Button, Pill } from "@productlane/ui"

import { toast } from "@/components/toast"
import { api } from "@/lib/api"

export function InviteItem({ invite }: { invite: WorkspaceInvite }) {
	const context = api.useUtils()

	const cancelInviteMutation = api.workspace.cancelInvite.useMutation({
		onSuccess: async () => {
			await context.workspace.invitedMembers.invalidate()
			toast.success({
				description: "Successfully cancelled invite!",
				title: "Invite Cancelled",
			})
		},
	})

	return (
		<div className="group flex items-center justify-between p-2">
			<div className="flex max-w-md items-center gap-4">
				<Avatar name={invite.inviteName ?? ""} roundness="full" />
				<div className="flex-1 truncate text-sm">
					<div className="flex items-end gap-2 truncate font-medium capitalize">
						{invite.inviteName}
						<Pill variant="dark-gray" className="capitalize" size="sm">
							Invited
						</Pill>
					</div>
					<div className="truncate break-all text-secondary">
						{invite.inviteEmail}
					</div>
				</div>
			</div>
			<Button
				variant="outline"
				className="opacity-0 transition group-hover:opacity-100"
				Icon={MailXIcon}
				onClick={() =>
					cancelInviteMutation.mutate({
						id: invite.id,
					})
				}
			>
				Cancel invite
			</Button>
		</div>
	)
}
